export const hi = {
    nav: {
        home: "होम", about: "हमारे बारे में", products: "उत्पाद",
        contact: "संपर्क करें", dealerLocator: "डीलर खोजें", tagline: "गुणवत्ता के साथ जुड़ाव",
        getInTouch: "संपर्क करें",
        changeLanguage: "भाषा बदलें",
        openMenu: "मेनू खोलें",
        closeMenu: "मेनू बंद करें",
        homeAria: "यूनिक बायोटेक रिसर्च — होम",
        logoAlt: "यूनिक बायोटेक रिसर्च लोगो",
    },
    hero: {
        badge: "ISO 9001:2008 प्रमाणित",
        headline: "यूनिक बायोटेक रिसर्च, पूरे भारत में किसानों का भरोसा।",
        sub: "2005 से बेहतर उपज, स्वस्थ मिट्टी और टिकाऊ खेती के लिए गुणवत्तापूर्ण कृषि उत्पाद।",
        cta1: "उत्पाद देखें", cta2: "संपर्क करें",
        highlight: "भारत",
        certified: "प्रमाणित",
        isoLabel: "ISO 9001:2008",
    },
    common: {
        yes: "हाँ",
        no: "नहीं",
        previous: "पिछला",
        next: "अगला",
    },
    cookies: {
        aria: "कुकी सहमति",
        title: "🍪 कुकी सूचना",
        message: "हम आपके ब्राउज़िंग अनुभव को बेहतर बनाने के लिए कुकीज़ का उपयोग करते हैं।",
        policy: "कुकी नीति",
        reject: "अस्वीकार करें",
        accept: "स्वीकार करें",
    },
    landing: {
        heroSub: "पूरे भारत के किसानों का भरोसा। 2005 से बेहतर उपज, स्वस्थ मिट्टी और टिकाऊ खेती के लिए गुणवत्तापूर्ण कृषि इनपुट।",
        heroCta1: "हमारे उत्पाद देखें",
        heroCta2: "हमारी टीम से बात करें",
        missionEyebrow: "हमारा मिशन",
        missionHeadingBefore: "नवाचार के माध्यम से",
        missionHighlight: "भारतीय कृषि",
        missionHeadingAfter: "को सशक्त बनाना",
        missionText: "यूनिक बायोटेक रिसर्च में हम विज्ञान, टिकाऊ खेती और नवोन्मेषी कृषि समाधानों को जोड़कर किसानों को मिट्टी का स्वास्थ्य सुधारने, फसल उत्पादकता बढ़ाने और कृषि के लिए अधिक टिकाऊ भविष्य बनाने में मदद करते हैं।",
        aboutEyebrow: "हमारे बारे में",
        aboutHeadingBefore: "किसानों के साथ आगे बढ़ते हुए",
        aboutHighlight: "2005 से",
        aboutP1: "2005 में पिंपलगांव बसवंत, नासिक में स्थापित — महाराष्ट्र के अंगूर और अनार बेल्ट के हृदय में — यूनिक बायोटेक रिसर्च एक सरल मिशन के साथ शुरू हुआ: किसानों को ऐसे गुणवत्तापूर्ण इनपुट देना जिन पर वे भरोसा कर सकें।",
        aboutP2: "दो दशकों में हम एक छोटे स्थानीय निर्माता से ISO-प्रमाणित कंपनी बन गए हैं, 100 से अधिक उत्पादों के साथ पूरे भारत में 10,000 से अधिक किसानों की अनुसंधान-आधारित कृषि समाधानों से सेवा कर रहे हैं।",
        aboutCta: "हमारे मील के पत्थरों के बारे में जानें",
        offerEyebrow: "हमारे उत्पाद",
        offerHeadingBefore: "हम क्या",
        offerHighlight: "प्रदान करते हैं",
        offerSub: "फसल स्वास्थ्य सुधारने, उत्पादकता बढ़ाने और टिकाऊ खेती को समर्थन देने के लिए विकसित हमारे विश्वसनीय कृषि समाधानों का चयन देखें।",
        offerCta: "और उत्पाद देखें",
        offerProducts: [
            { name: "Aminorich", line: "80% अमीनो एसिड, हर वृद्धि चरण के लिए 18 प्रकार", category: "अमीनो एसिड और बायोस्टिमुलेंट्स" },
            { name: "Excess", line: "12 सक्रिय प्रकारों वाला उच्च शक्ति बायोस्टिमुलेंट", category: "अमीनो एसिड और बायोस्टिमुलेंट्स" },
            { name: "Unisearich", line: "शुद्ध एस्कोफिलम समुद्री शैवाल अर्क", category: "बायोस्टिमुलेंट" },
        ],
        networkEyebrow: "पैन इंडिया नेटवर्क",
        networkHeading: "मज़बूत नेटवर्क।",
        networkHighlight: "साथ मिलकर और मज़बूत।",
        networkSub: "यूनिक बायोटेक रिसर्च एक विश्वसनीय राष्ट्रव्यापी डीलर नेटवर्क बना रहा है जो भरोसेमंद स्थानीय सहायता के माध्यम से किसानों को गुणवत्तापूर्ण कृषि समाधानों से जोड़ता है।",
        networkCta: "डीलर बनें",
        networkMapAria: "भारत वितरण नेटवर्क मानचित्र",
        networkFeatures: [
            { title: "व्यापक पहुंच", text: "प्रमुख कृषि क्षेत्रों में विश्वसनीय कृषि इनपुट तक पहुंच बढ़ाना।" },
            { title: "विश्वसनीय साझेदारी", text: "स्थानीय किसानों को समझने वाले डीलरों के साथ स्थायी संबंध बनाना।" },
            { title: "भरोसेमंद सहायता", text: "हर मौसम में ज़मीनी सहायता और समय पर मार्गदर्शन।" },
            { title: "साथ मिलकर विकास", text: "गुणवत्तापूर्ण उत्पादों और भरोसेमंद सेवा से समुदायों को आगे बढ़ने में मदद।" },
        ],
        testimonialsBadge: "किसान प्रशंसापत्र",
        testimonialsHeadingBefore: "हमारे",
        testimonialsHighlight: "किसान",
        testimonialsHeadingAfter: "क्या कहते हैं",
        testimonialsSub: "उन किसानों के वास्तविक अनुभव जो बेहतर उपज, स्वस्थ मिट्टी और मज़बूत फसलों के लिए यूनिक बायोटेक रिसर्च पर भरोसा करते हैं।",
        testimonialsPrev: "पिछला प्रशंसापत्र",
        testimonialsNext: "अगला प्रशंसापत्र",
        testimonialsGoTo: "प्रशंसापत्र पर जाएँ",
        stories: [
            { name: "रमेश पाटिल", meta: "अंगूर • नासिक", quote: "AminoRich अपनाने के बाद बेरी का आकार स्पष्ट रूप से बेहतर हुआ। मेरे खरीदारों ने लगातार दूसरे सीज़न में भी प्रीमियम कीमतें दीं।" },
            { name: "सुनील देशमुख", meta: "कपास • विदर्भ", quote: "Rhyzomax ने मानसून के तनाव से मेरी फसल को उबरने में मदद की। पड़ोसी के खेत की तुलना में जड़ें स्पष्ट रूप से मोटी थीं।" },
            { name: "लक्ष्मी रेड्डी", meta: "मिर्च • गुंटूर", quote: "Excess के तीन अनुप्रयोगों के बाद छत्र अजनबी लगने लगा। शाखाओं की संख्या लगभग दोगुनी हो गई, और फसल भी।" },
        ],
        ctaEyebrow: "यूनिक बायोटेक रिसर्च के साथ आगे बढ़ें",
        ctaHeading: "स्वस्थ फसलें और बेहतर उपज के लिए तैयार हैं?",
        ctaText: "अपनी मिट्टी, मौसम और फसल के लिए सही इनपुट खोजने हेतु हमारे कृषिविदों के साथ साझेदारी करें — भरोसेमंद गुणवत्ता और ज़मीनी सहायता के साथ।",
        ctaWhatsapp: "WhatsApp पर चैट करें",
    },
    stats: {
        years: "20+", yearsLabel: "उत्कृष्टता के वर्ष",
        cert: "ISO", certLabel: "9001:2008 प्रमाणित",
        customers: "10,000+", customersLabel: "खुश किसान",
        products: "100+", productsLabel: "उत्पाद",
    },
    home: {
        featuredLabel: "हमारे उत्पाद",
        featuredTitle: "खेती के हर चरण के लिए तैयार कृषि समाधान",
        featuredSub: "मृदा पोषण से लेकर फसल सुरक्षा तक, हमारे उत्पाद वर्षों के कृषि अनुसंधान से विकसित किए गए हैं ताकि किसान स्वस्थ फसल और बेहतर उपज प्राप्त कर सकें।",
        featuredNote: "2005 से भारतीय किसानों को बेहतर फसल उगाने में मदद",
        featuredExploreAll: "सभी उत्पाद देखें",
        featuredCards: ["जैव उर्वरक", "पौध वृद्धि प्रवर्तक", "फसल सुरक्षा", "सूक्ष्म पोषक तत्व"],
        explore: "एक्सप्लोर करें",
        cropsTitle: "जिन फसलों के लिए हम काम करते हैं",
        aboutLabel: "हमारे बारे में",
        aboutTitle: "यूनिक बायोटेक रिसर्च के बारे में",
        aboutSub: "2005 में नासिक, महाराष्ट्र में स्थापित, हम पूरे भारत में किसानों को उच्चतम गुणवत्ता वाले कृषि इनपुट प्रदान करने के लिए प्रतिबद्ध हैं। हमारी ISO 9001:2008 प्रमाणित सुविधा सुनिश्चित करती है कि हर उत्पाद उच्चतम मानकों को पूरा करे।",
        aboutCta: "और जानें",
        aboutEyebrow: "यूनिक बायोटेक रिसर्च के बारे में",
        aboutHeading: "नवाचार के माध्यम से बेहतर कृषि",
        aboutHighlight: "नवाचार",
        aboutP1: "यूनिक बायोटेक रिसर्च 2005 से भारतीय किसानों की सेवा कर रही है। हम नासिक, महाराष्ट्र में स्थित हैं, जो देश के अंगूर और अनार बेल्ट का केंद्र है।",
        aboutP2: "हमारा काम विज्ञान पर आधारित है। हर उत्पाद सावधानीपूर्वक शोध से तैयार होता है और खेत तक पहुंचने से पहले हमारी ISO 9001 प्रमाणित सुविधा में परखा जाता है।",
        aboutP3: "आज हम छह श्रेणियों में 100 से अधिक उत्पाद प्रदान करते हैं। हर उत्पाद फसल के स्वास्थ्य, बेहतर उपज और मिट्टी की दीर्घकालिक उर्वरता के लिए बनाया गया है।",
        aboutBtn: "और जानें",
        aboutAchievements: [
            { title: "ISO 9001 प्रमाणित", sub: "भरोसेमंद गुणवत्ता" },
            { title: "100+ उत्पाद", sub: "नवोन्मेषी समाधान" },
            { title: "20+ वर्ष", sub: "कृषि विशेषज्ञता के" },
        ],
        aboutFloating: [
            { title: "20+ वर्ष", sub: "कृषि विशेषज्ञता और भरोसा" },
            { title: "टिकाऊ खेती", sub: "बेहतर कल के लिए समाधान" },
            { title: "अनुसंधान आधारित", sub: "विज्ञान समर्थित नवाचार" },
            { title: "गुणवत्ता आश्वस्त", sub: "हर कदम पर कठोर गुणवत्ता" },
        ],
        aboutStatementTitle: "2005 से किसानों के साथ आगे बढ़ते हुए",
        aboutStatementText: "गुणवत्ता, अनुसंधान और टिकाऊ प्रथाओं के माध्यम से नवोन्मेषी जैव प्रौद्योगिकी समाधानों से किसानों की मदद करना।",
        ctaTitle: "क्या आप अपनी उपज में सुधार करने के लिए तैयार हैं?",
        ctaSub: "हमारे कृषिविदों (Agronomists) से बात करें और अपनी फसलों के लिए सही उत्पाद खोजें।",
        ctaEyebrow: "बेहतर उगाने के लिए तैयार हैं?",
        ctaHeading: "आइए एक हरित, सशक्त कल बनाएँ।",
        ctaHighlight: "कल",
        ctaText: "नवाचारी समाधानों, विश्वसनीय गुणवत्ता और टिकाऊ भविष्य के लिए Unik Biotech Research के साथ साझेदारी करें।",
        ctaCall: "अभी कॉल करें", ctaWhatsapp: "WhatsApp",
        viewAll: "सभी उत्पाद देखें",
    },
    why: {
        eyebrow: "यूनिक बायोटेक रिसर्च क्यों चुनें",
        heading: "हजारों किसान यूनिक बायोटेक रिसर्च क्यों चुनते हैं",
        highlight: "यूनिक बायोटेक रिसर्च",
        sub: "हम किसानों की बेहतर पैदावार के लिए विज्ञान, नवाचार और प्रकृति को जोड़ते हैं। भरोसेमंद गुणवत्ता जो फसल की रक्षा करती है और मिट्टी को स्वस्थ रखती है।",
        cards: [
            { title: "विज्ञान आधारित", desc: "हर उत्पाद उन्नत अनुसंधान और वैज्ञानिक परीक्षण से तैयार होता है।" },
            { title: "उच्च उपज प्रदर्शन", desc: "स्पष्ट परिणाम देने और फसल उत्पादकता बढ़ाने के लिए तैयार किया गया।" },
            { title: "गुणवत्ता आश्वस्त", desc: "हर चरण में अंतरराष्ट्रीय मानकों के अनुरूप कठोर गुणवत्ता नियंत्रण।" },
            { title: "टिकाऊ खेती", desc: "स्वस्थ मिट्टी, बेहतर उपज और टिकाऊ भविष्य के लिए समाधान।" },
            { title: "किसान प्रथम दृष्टिकोण", desc: "असल खेती की चुनौतियों को हल करने और किसानों की मदद के लिए बनाया गया।" },
            { title: "अनुसंधान से नवाचार", desc: "प्रभावी और सुरक्षित कृषि समाधान बनाने के लिए निरंतर अनुसंधान।" },
            { title: "आधुनिक कृषि समाधान", desc: "नए विचार और तकनीक जो खेती को सरल और अधिक कुशल बनाते हैं।" },
            { title: "ISO प्रमाणित", desc: "ISO 9001:2008 प्रमाणित गुणवत्ता प्रबंधन प्रणाली द्वारा समर्थित।" },
        ],
        stats: [
            { value: "20+", label: "उत्कृष्टता के वर्ष" },
            { value: "100+", label: "प्रीमियम उत्पाद" },
            { value: "10,000+", label: "सेवित किसान" },
            { value: "ISO", label: "9001:2008 प्रमाणित" },
        ],
    },
    about: {
        hero: "हमारे बारे में",
        heroSub: "गुणवत्ता और नवाचार के साथ किसानों की सेवा के 20 साल",
        missionTitle: "हमारा मिशन",
        missionText: "वैज्ञानिक रूप से उन्नत, उच्च गुणवत्ता वाले कृषि उत्पादों के साथ किसानों को सशक्त बनाना जो फसल के स्वास्थ्य, उपज और मिट्टी की उर्वरता में सुधार करते हैं, स्थायी और किफायती रूप से।",
        visionTitle: "हमारा विजन",
        visionText: "पारंपरिक कृषि ज्ञान के साथ आधुनिक जैव प्रौद्योगिकी को जोड़कर, भारत में सबसे भरोसेमंद कृषि उत्पाद ब्रांड बनना।",
        storyLabel: "हमारी जड़ें",
        storyTitle: "हमारी कहानी",
        storyText: "महाराष्ट्र अंगूर और अनार बेल्ट के बीच, नाशिक के पिंपलगांव बसवंत में 2005 में स्थापित, यूनिक बायोटेक रिसर्च एक साधारण मिशन के साथ शुरू हुआ: किसानों को गुणवत्तापूर्ण उत्पाद प्रदान करना जिस पर वे भरोसा कर सकें। दो दशकों में, हम एक छोटे स्थानीय निर्माता से एक ISO-प्रमाणित कंपनी में विकसित हुए हैं जो पूरे भारत में 100+ उत्पादों के साथ 10,000+ किसानों की सेवा कर रही है।",
        establishedLabel: "स्थापित",
        statEstablished: "स्थापित",
        statLocation: "स्थान",
        statLocationWrap: "नाशिक, MH",
        statProducts: "उत्पाद",
        statCert: "प्रमाणपत्र",
        statYearsWrap: "20+ साल",
        legacyLabel: "हमारी विरासत",
        journeyTitle: "सफलता के मील के पत्थर",
        journeySub: "साधारण शुरुआत से लेकर कृषि में एक विश्वसनीय साझेदार बनने तक, हमारी यात्रा विश्वास, नवाचार और प्रभाव पर आधारित है।",
        growTitle: "आइए साथ मिलकर आगे बढ़ें",
        growText: "किसानों को नवीन समाधानों और सतत विकास के साथ सशक्त बनाने के हमारे मिशन में शामिल हों।",
        growBecome: "डीलर बनें",
        growFind: "डीलर खोजें",
        certTitle: "गुणवत्ता एवं प्रमाणपत्र",
        valuesTitle: "हमारे मूल मूल्य",
        values: [
            { title: "गुणवत्ता प्रथम", desc: "किसानों तक पहुंचने से पहले हर उत्पाद कठोर गुणवत्ता जांच से गुजरता है।" },
            { title: "किसान केंद्रित", desc: "हमारे निर्णय इस बात से निर्देशित होते हैं कि किसान के लिए सबसे अच्छा क्या है।" },
            { title: "नवाचार", desc: "हम किसानों को नवीनतम कृषि विज्ञान प्रदान करने के लिए R&D में निवेश करते हैं।" },
            { title: "भरोसा", desc: "2005 से किसानों और डीलरों के साथ स्थायी संबंध बनाना।" },
        ],
        certs: [
            { title: "ISO 9001:2008", desc: "ISO 9001:2008 प्रमाणित — गुणवत्ता प्रबंधन प्रणाली" },
            { title: "प्रयोगशाला में परीक्षित", desc: "डिस्पैच से पहले हर उत्पाद हमारी लैब में कठोर परीक्षण से गुजरता है" },
            { title: "नासिक में निर्मित", desc: "पिंपलगांव बसवंत, नासिक, महाराष्ट्र में विनिर्माण" },
        ],
        pageValues: [
            { title: "गुणवत्ता", desc: "गुणवत्ता हमारी नींव है। हर उत्पाद सावधानी और सटीकता से बनाया जाता है।" },
            { title: "टीमवर्क", desc: "साथ मिलकर हम आगे बढ़ते हैं। हमारी टीम उत्कृष्टता के लिए सहयोग करती है।" },
            { title: "नवाचार", desc: "निरंतर नवाचार के साथ कृषि के भविष्य का नेतृत्व।" },
            { title: "समयबद्धता", desc: "हर बार समय पर डिलीवरी। भरोसा जिस पर आप गिनती कर सकते हैं।" },
        ],
        milestones: [
            { year: "2005", title: "स्थापना", desc: "किसानों की सेवा के विजन के साथ पिंपलगांव बसवंत, नासिक में यूनिक बायोटेक रिसर्च की स्थापना।" },
            { year: "2008", title: "मज़बूत नींव", desc: "गुणवत्तापूर्ण कृषि इनपुट के विनिर्माण को मजबूत किया और जमीनी स्तर पर विश्वास बनाया।" },
            { year: "2012", title: "और आगे बढ़ना", desc: "उत्पाद श्रृंखला का विस्तार और पूरे महाराष्ट्र में वितरण को मजबूत किया।" },
            { year: "2017", title: "हजारों का भरोसा", desc: "हजारों किसानों तक पहुँचे और एक भरोसेमंद कृषि साझेदार बने।" },
            { year: "2020", title: "ISO प्रमाणित", desc: "गुणवत्ता प्रबंधन प्रणालियों के लिए ISO 9001:2008 प्रमाणन प्राप्त किया।" },
            { year: "2025+", title: "भविष्य का रूपांतरण", desc: "बेहतर कल के लिए टिकाऊ, प्रभावी और किसान-प्रथम समाधानों के साथ नवाचार जारी।" },
        ],
    },
    products: {
        title: "हमारे उत्पाद",
        sub: "हर जरूरत के लिए कृषि इनपुट की पूरी रेंज",
        filterLabel: "श्रेणी के अनुसार फ़िल्टर करें",
        searchLabel: "उत्पाद खोजें...",
        enquire: "पूछताछ करें", viewDetails: "विवरण देखें",
        benefits: "मुख्य लाभ", composition: "संरचना",
        dosage: "मात्रा और उपयोग", form: "रूप",
        packing: "पैकिंग",
        crops: "उपयुक्त फसलें", close: "बंद करें",
        noResults: "कोई उत्पाद नहीं मिला। कोई अन्य श्रेणी या खोज शब्द आज़माएँ।",
        productCountLabel: "उत्पाद मिले",
        enquireCall: "पूछताछ के लिए कॉल करें: +91 7666272741",
        clearSearch: "खोज साफ़ करें",
        badgeMicronutrient: "सूक्ष्म पोषक",
        badgeBiostimulant: "बायोस्टिमुलेंट",
        badgeProtection: "सुरक्षा",
        badgeSoil: "मृदा सुधारक",
        badgeBiofertilizer: "जैव उर्वरक",
        badgeSpreader: "स्प्रेडर और स्टिकर",
        ctaTitle: "जो आप ढूंढ रहे हैं वह नहीं मिला?",
        ctaText: "आपकी फसलों के लिए सही समाधान चुनने में हमारी टीम आपकी मदद के लिए यहाँ है।",
        ctaBtn: "हमारे विशेषज्ञों से बात करें",
        quickView: "त्वरित दृश्य",
        viewFullDetails: "पूर्ण उत्पाद पृष्ठ देखें",
        backToProducts: "उत्पादों पर वापस जाएं",
        notFoundTitle: "उत्पाद नहीं मिला",
        notFoundText: "आप जिस उत्पाद की तलाश कर रहे हैं वह नहीं मिला। हो सकता है इसका नाम बदल दिया गया हो या यह अब सूचीबद्ध न हो।",
        notFoundCta: "सभी उत्पाद देखें",
    },
    categories: {
        all: "सभी उत्पाद",
        micronutrient: "सूक्ष्म पोषक उर्वरक",
        biostimulant: "अमीनो एसिड और बायोस्टिमुलेंट्स",
        protection: "फसल संरक्षण",
        soil: "मृदा सुधारक",
        biofertilizer: "जैव उर्वरक",
        spreader: "स्प्रेडर और स्टिकर",
    },
    contact: {
        title: "संपर्क करें",
        sub: "स्वस्थ और अधिक उत्पादक कल के लिए सर्वश्रेष्ठ समाधानों में हम आपकी मदद के लिए यहाँ हैं।",
        formTitle: "हमें एक संदेश भेजें",
        name: "आपका नाम", namePlaceholder: "पूरा नाम",
        phone: "फोन नंबर", phonePlaceholder: "फोन नंबर",
        email: "ईमेल (वैकल्पिक)", emailPlaceholder: "ईमेल पता",
        cropType: "फसल का प्रकार", cropPlaceholder: "अपनी फसल चुनें",
        message: "संदेश", messagePlaceholder: "संदेश",
        subjectPlaceholder: "विषय",
        submit: "संदेश भेजें",
        success: "संदेश सफलतापूर्वक भेजा गया! हम आपसे जल्द ही संपर्क करेंगे।",
        error: "भेजने में विफल। कृपया हमें सीधे कॉल करने का प्रयास करें।",
        fillError: "कृपया अपना नाम, फोन नंबर और संदेश भरें।",
        sending: "भेजा जा रहा है...",
        infoTitle: "संपर्क करें",
        address: "पता", phone2: "ग्राहक सेवा", emailLabel: "ईमेल", website: "वेबसाइट",
        whatsapp: "WhatsApp पर चैट करें",
        whatsappSub: "तुरंत जवाब पाएं",
        addressLabel: "हमारा पता",
        emailUs: "हमें ईमेल करें",
        callUs: "हमें कॉल करें",
        formEyebrow: "हमें संदेश भेजें",
        formHeading: "हमें आपसे सुनना अच्छा लगेगा",
        formIntro: "कोई प्रश्न, सुझाव या सहायता चाहिए? फ़ॉर्म भरें और हमारी टीम जल्द ही आपसे संपर्क करेगी।",
        locationEyebrow: "हमारा स्थान",
        locationHeading: "हमें यहाँ खोजें",
        locationText: "किसी भी पूछताछ या व्यावसायिक चर्चा के लिए हमारे कार्यालय पर आएँ। सही कृषि समाधान खोजने में हमारी टीम तैयार है।",
        viewLargerMap: "बड़ा मानचित्र देखें",
        mapTitle: "यूनिक बायोटेक रिसर्च का स्थान",
        addressLines: [
            "Unik Biotech Research",
            "B-178, S.S. Co-Op. Ind. Estate,",
            "Pimpalgaon (B), Tal. Niphad,",
            "Dist. Nashik - 422 209,",
            "Maharashtra, India",
        ],
        mapAddressShort: "B-178, S.S. Co-Op. Ind. Estate, Pimpalgaon (B), Tal. Niphad, Dist. Nashik - 422 209, Maharashtra",
    },
    dealer: {
        title: "डीलर खोजें",
        sub: "यूनिक बायोटेक रिसर्च डीलर नेटवर्क से जुड़ें और किसानों को सशक्त बनाने व मज़बूत कृषि भविष्य बनाने के हमारे मिशन का हिस्सा बनें।",
        searchTitle: "डीलर खोजें",
        searchSub: "निकटतम अधिकृत डीलर का पता लगाने के लिए अपना जिला या गांव दर्ज करें",
        district: "जिला", districtPlaceholder: "उदा. नासिक, पुणे, छत्रपति संभाजीनगर",
        searchBtn: "डीलर खोजें",
        becomeTitle: "डीलर बनें",
        becomeSub: "यूनिक बायोटेक रिसर्च के साथ साझेदारी करें और हमारे विश्वसनीय उत्पादों, सहायता और मार्गदर्शन से अपना व्यवसाय बढ़ाएँ।",
        networkTitle: "हमारा वितरण नेटवर्क",
        networkSub: "यूनिक बायोटेक रिसर्च का पूरे महाराष्ट्र में एक विस्तृत डीलर नेटवर्क है।",
        applyName: "पूरा नाम", applyPhone: "फोन", applyDistrict: "जिला", applyVillage: "गांव/शहर",
        applySubmit: "डीलर बनने के लिए आवेदन करें",
        applySuccess: "आवेदन जमा हो गया! हमारी टीम 24 घंटों के भीतर आपसे संपर्क करेगी।",
        applyErrSub: "कुछ गलत हो गया। कृपया पुन: प्रयास करें।",
        applyErrFill: "कृपया अपना नाम, मोबाइल नंबर, शहर और जिला भरें।",
        applyErrAgree: "कृपया यूनिक बायोटेक रिसर्च द्वारा संपर्क किए जाने की सहमति दें।",
        applyBtnSubmitting: "जमा हो रहा है...",
        namePlaceholder: "अपना पूरा नाम",
        villagePlaceholder: "गांव या शहर",
        foundTitle: "आपके जिले में डीलर उपलब्ध हैं!",
        foundDesc: "डीलर विवरण के लिए कृपया हमें कॉल करें: +91 7666272741",
        notFoundTitle: "आपके क्षेत्र में वर्तमान में कोई डीलर नहीं है।",
        notFoundDesc: "डीलर बनने के लिए नीचे आवेदन करें या हमसे सीधे संपर्क करें।",
        districtsServes: "हम सेवा देते हैं",
        headOffice: "प्रधान कार्यालय",
        benefits: [
            "आपके क्षेत्र में विशेष डीलर अधिकार",
            "पूर्ण उत्पाद प्रशिक्षण और तकनीकी सहायता",
            "50+ उत्पादों पर आकर्षक मार्जिन",
            "विपणन सामग्री और क्षेत्रीय सहयोग",
            "नासिक प्रधान कार्यालय से सीधा सहयोग"
        ],
        heroHeadingBefore: "साथ मिलकर,",
        heroHighlight: "बेहतर",
        heroHeadingAfter: "उगाएँ",
        findTitle: "डीलर खोजें",
        findSub: "अपने निकटतम अधिकृत डीलर का पता लगाएँ और विशेषज्ञ सलाह के साथ असली उत्पाद पाएँ।",
        applyNow: "अभी आवेदन करें",
        formEyebrow: "डीलर बनें",
        formHeading: "हमारे डीलर नेटवर्क से जुड़ें",
        formIntro: "यूनिक बायोटेक रिसर्च के साथ साझेदारी करें और विश्वसनीय कृषि समाधानों, तकनीकी सहायता और भारत भर के मज़बूत डीलर नेटवर्क के साथ अपना व्यवसाय बढ़ाएँ।",
        firmLabel: "व्यवसाय / फर्म का नाम",
        firmPlaceholder: "आपके व्यवसाय का नाम",
        mobileLabel: "मोबाइल नंबर",
        emailLabel: "ईमेल पता",
        cityLabel: "शहर",
        cityPlaceholder: "आपका शहर",
        stateLabel: "राज्य",
        selectDistrict: "जिला चुनें",
        selectState: "राज्य चुनें",
        pinLabel: "पिन कोड",
        pinPlaceholder: "उदा. 422209",
        experienceLabel: "कृषि व्यवसाय में वर्ष",
        selectExperience: "अनुभव चुनें",
        productsLabel: "रुचि के उत्पाद",
        selectProducts: "उत्पाद चुनें",
        existingCustomer: "मौजूदा ग्राहक?",
        messageLabel: "अतिरिक्त संदेश",
        messagePlaceholder: "अपना संदेश यहाँ लिखें...",
        agreeText: "मैं यूनिक बायोटेक रिसर्च द्वारा संपर्क किए जाने के लिए सहमत हूँ।",
        respondTitleBefore: "हम जवाब देते हैं",
        respondHighlight: "24 घंटे",
        respondSub: "हमारी टीम जल्द ही आपसे जुड़ेगी।",
        availableEyebrow: "हमारा नेटवर्क",
        availableTitle: "उपलब्ध डीलर",
        availableSub: "असली उत्पाद, विशेषज्ञ मार्गदर्शन और भरोसेमंद कृषि समाधानों के लिए अपने निकटतम अधिकृत यूनिक बायोटेक रिसर्च डीलर से जुड़ें।",
        showing: "दिखा रहा है",
        dealersCount: "डीलर",
        authorizedBadge: "अधिकृत डीलर",
        availableProducts: "उपलब्ध उत्पाद",
        callDealer: "डीलर को कॉल करें",
        directions: "दिशा-निर्देश",
        statsDealers: "डीलर",
        statsDistricts: "जिले",
        statsYears: "वर्षों का भरोसा",
        experienceOptions: ["1 वर्ष से कम", "1 – 3 वर्ष", "3 – 5 वर्ष", "5 – 10 वर्ष", "10+ वर्ष"],
        productInterests: ["जैव उर्वरक", "पौध वृद्धि प्रवर्तक", "फसल सुरक्षा", "सूक्ष्म पोषक तत्व", "समुद्री शैवाल अर्क", "सभी उत्पाद"],
        faqTitle: "अक्सर पूछे जाने वाले प्रश्न",
        faqSub: "अधिकृत यूनिक बायोटेक डीलर बनने और डीलर लोकेटर उपयोग के सामान्य प्रश्नों के उत्तर पाएँ।",
        faqs: [
            { question: "अधिकृत यूनिक बायोटेक डीलर कौन बन सकता है?", answer: "कृषि खुदरा विक्रेता, वितरक, कृषि-इनपुट व्यवसाय और कृषि क्षेत्र से जुड़े उद्यमी अधिकृत डीलर बनने के लिए आवेदन कर सकते हैं।" },
            { question: "अनुमोदन प्रक्रिया में कितना समय लगता है?", answer: "आवेदन जमा होने के बाद हमारी टीम समीक्षा करती है और सत्यापन पूरा होने पर पात्र आवेदकों से संपर्क करती है।" },
            { question: "क्या कृषि उत्पादों का पिछला अनुभव आवश्यक है?", answer: "पिछला अनुभव लाभदायक है लेकिन अनिवार्य नहीं। नई डीलरों को उत्पाद और प्रक्रियाएँ समझने में हमारी टीम मार्गदर्शन देती है।" },
            { question: "यूनिक बायोटेक डीलरों को क्या सहायता देता है?", answer: "डीलरों को उत्पाद जानकारी, तकनीकी मार्गदर्शन, प्रचार सहायता और हमारी बिक्री टीम का सहयोग मिलता है।" },
            { question: "क्या मैं भारत के किसी भी राज्य से आवेदन कर सकता हूँ?", answer: "हाँ। हम पूरे भारत से आवेदन स्वागत करते हैं, जो हमारे डीलर नेटवर्क की आवश्यकताओं के अधीन हैं।" },
            { question: "मैं निकटतम डीलर कैसे खोजूँ?", answer: "ऊपर दिए डीलर लोकेटर में डीलर नाम, शहर, जिला या राज्य से खोजें।" },
        ],
    },
    footer: {
        tagline: "गुणवत्ता के साथ जुड़ाव",
        desc: "दो दशकों से अधिक समय से भारतीय किसानों का भरोसा, अनुसंधान आधारित कृषि समाधान।",
        quickLinks: "त्वरित लिंक", productsLink: "उत्पाद", contactLink: "संपर्क",
        categories: "उत्पाद श्रेणियां", address: "पता", phone: "ग्राहक सेवा",
        rights: "सर्वाधिकार सुरक्षित।",
        estLine: "स्था. 2005 | नासिक, महाराष्ट्र, भारत",
        companyAddress: "B-178, S.S. Co-Op. Ind. Estate, Pimpalgaon (B), Tal. Niphad, Dist. Nashik - 422 209",
        journeyTitle: "हमारी यात्रा",
        contactBtn: "संपर्क करें",
        madeFor: "भारतीय कृषि के लिए निर्मित।",
        journey: [
            { value: "20+", label: "वर्षों का भरोसा" },
            { value: "ISO 9001:2008", label: "प्रमाणित" },
            { value: "100+", label: "उत्पाद" },
            { value: "10,000+", label: "किसान" },
        ],
    },
    cookiePolicy: {
        title: "कुकी नीति",
        subtitle: "यह पृष्ठ बताता है कि हमारी वेबसाइट पर कुकीज़ का उपयोग कैसे किया जा सकता है। अंतिम नीति सामग्री क्लाइंट द्वारा प्रदान की जाएगी।",
        onThisPage: "इस पृष्ठ पर",
        sections: [
            {
                id: "what-are-cookies",
                title: "कुकीज़ क्या हैं?",
                paragraphs: [
                    "कुकीज़ छोटी टेक्स्ट फ़ाइलें होती हैं जो किसी वेबसाइट पर जाने पर आपके डिवाइस पर रखी जाती हैं। इनका व्यापक रूप से उपयोग वेबसाइटों को अधिक कुशलता से चलाने और साइट स्वामियों को जानकारी देने के लिए किया जाता है।",
                    "जब आप हमारी वेबसाइट पर आते हैं, तो कुकीज़ आपके कंप्यूटर, टैबलेट या मोबाइल डिवाइस पर संग्रहीत की जा सकती हैं। इन फ़ाइलों में ऐसी जानकारी होती है जो वेबसाइट को बाद की यात्राओं पर आपके डिवाइस को पहचानने में मदद करती है।",
                    "कुकीज़ आपके डिवाइस पर मौजूद अन्य जानकारी तक नहीं पहुँच सकतीं और न ही आपके कंप्यूटर को नुकसान पहुँचाती हैं। इन्हें आपकी प्राथमिकताओं को याद रखकर और कुछ साइट कार्यक्षमताओं को सक्षम करके आपके ब्राउज़िंग अनुभव को बेहतर बनाने के लिए बनाया गया है।",
                ],
            },
            {
                id: "why-we-use-cookies",
                title: "हम कुकीज़ का उपयोग क्यों करते हैं",
                paragraphs: [
                    "हम कुकीज़ का उपयोग यह सुनिश्चित करने के लिए करते हैं कि हमारी वेबसाइट ठीक से काम करे और यह समझने के लिए कि आगंतुक हमारी सामग्री के साथ कैसे संवाद करते हैं। इससे हमें हमारी साइट का उपयोग करने वाले सभी लोगों को बेहतर अनुभव देने में मदद मिलती है।",
                    "कुकीज़ हमें आपकी सेटिंग्स और प्राथमिकताएँ, जैसे भाषा विकल्प या प्रदर्शन विकल्प, याद रखने देती हैं, ताकि आपको हर बार आने पर उन्हें दोबारा दर्ज न करना पड़े।",
                    "हम साइट ट्रैफ़िक और उपयोग के पैटर्न का विश्लेषण करने के लिए भी कुकीज़ का उपयोग कर सकते हैं। यह जानकारी हमें हमारी वेबसाइट के डिज़ाइन, सामग्री और समग्र प्रदर्शन को बेहतर बनाने में मदद करती है।",
                    "कुछ कुकीज़ वेबसाइट के संचालन के लिए आवश्यक हैं, जबकि अन्य आपके अनुभव को बेहतर बनाने या हमारे मार्केटिंग प्रयासों का समर्थन करने में मदद करती हैं। आप नीचे दिए गए अनुभागों में प्रत्येक श्रेणी के बारे में अधिक जान सकते हैं।",
                ],
            },
            {
                id: "types-of-cookies",
                title: "हम किस प्रकार की कुकीज़ का उपयोग करते हैं",
                paragraphs: [
                    "हम अपनी वेबसाइट पर कई श्रेणियों की कुकीज़ का उपयोग कर सकते हैं। आवश्यक कुकीज़ बुनियादी साइट कार्यक्षमता, जैसे नेविगेशन और सुरक्षित क्षेत्रों तक पहुँच, के लिए आवश्यक होती हैं।",
                    "प्रदर्शन और एनालिटिक्स कुकीज़ हमें यह समझने में मदद करती हैं कि आगंतुक हमारी वेबसाइट का उपयोग कैसे करते हैं, पृष्ठ यात्राओं, ट्रैफ़िक स्रोतों और उपयोगकर्ता व्यवहार के बारे में अनाम जानकारी एकत्र करके।",
                    "कार्यक्षमता कुकीज़ वेबसाइट को आपके द्वारा किए गए चयनों को याद रखने और उन्नत, व्यक्तिगत सुविधाएँ प्रदान करने देती हैं। मार्केटिंग कुकीज़ का उपयोग प्रासंगिक सामग्री देने या हमारे संचार की प्रभावशीलता मापने के लिए किया जा सकता है।",
                ],
            },
            {
                id: "managing-preferences",
                title: "अपनी कुकी प्राथमिकताएँ प्रबंधित करना",
                paragraphs: [
                    "हमारी वेबसाइट पर कुकीज़ का उपयोग कैसे किया जाता है, इस बारे में आपके पास विकल्प हैं। अधिकांश वेब ब्राउज़र आपको उनकी सेटिंग्स के माध्यम से कुकीज़ को नियंत्रित करने की अनुमति देते हैं, जिसमें कुकीज़ को ब्लॉक करने या हटाने की क्षमता शामिल है।",
                    "आप सभी कुकीज़ को अस्वीकार करने या कुकी भेजे जाने पर आपको सूचित करने के लिए अपनी ब्राउज़र सेटिंग्स समायोजित कर सकते हैं। कृपया ध्यान दें कि कुछ कुकीज़ को अक्षम करने से हमारी वेबसाइट की कार्यक्षमता प्रभावित हो सकती है और कुछ सुविधाओं का उपयोग करने की आपकी क्षमता सीमित हो सकती है।",
                    "यदि हमारी वेबसाइट कोई कुकी प्राथमिकता उपकरण प्रदान करती है, तो आप इसका उपयोग यह अनुकूलित करने के लिए कर सकते हैं कि आप कौन-सी वैकल्पिक कुकीज़ स्वीकार करते हैं। आपकी प्राथमिकताएँ आमतौर पर किसी भी समय अपडेट की जा सकती हैं।",
                ],
            },
            {
                id: "third-party-cookies",
                title: "तृतीय-पक्ष कुकीज़",
                paragraphs: [
                    "हमारी वेबसाइट पर कुछ कुकीज़ उन तृतीय-पक्ष सेवाओं द्वारा सेट की जा सकती हैं जो हमारे पृष्ठों पर दिखाई देती हैं। इन तृतीय पक्षों में एनालिटिक्स प्रदाता, एम्बेडेड सामग्री प्लेटफ़ॉर्म या सोशल मीडिया एकीकरण शामिल हो सकते हैं।",
                    "हम तृतीय पक्षों द्वारा रखी गई कुकीज़ को नियंत्रित नहीं करते, और उनका उपयोग संबंधित तृतीय पक्ष की गोपनीयता और कुकी नीतियों द्वारा नियंत्रित होता है। हम आपको अधिक जानकारी के लिए उन नीतियों की समीक्षा करने के लिए प्रोत्साहित करते हैं।",
                    "तृतीय-पक्ष कुकीज़ विभिन्न वेबसाइटों पर आपकी ब्राउज़िंग गतिविधि के बारे में जानकारी एकत्र कर सकती हैं। इससे उन सेवाओं को अपनी पेशकशों के हिस्से के रूप में एनालिटिक्स, विज्ञापन या अन्य सुविधाएँ प्रदान करने में मदद मिलती है।",
                ],
            },
            {
                id: "policy-changes",
                title: "इस कुकी नीति में परिवर्तन",
                paragraphs: [
                    "हम अपनी प्रथाओं, तकनीक या व्यावसायिक संचालन में बदलावों को दर्शाने के लिए समय-समय पर इस कुकी नीति को अपडेट कर सकते हैं। जब हम बदलाव करते हैं, तो हम इस पृष्ठ के शीर्ष या तल पर दी गई तारीख को संशोधित करेंगे।",
                    "हम आपको यह जानने के लिए कि हम कुकीज़ का उपयोग कैसे करते हैं, समय-समय पर इस नीति की समीक्षा करने के लिए प्रोत्साहित करते हैं। किसी भी अपडेट के बाद हमारी वेबसाइट का निरंतर उपयोग संशोधित नीति के प्रति आपकी स्वीकृति मानी जाएगी।",
                    "यदि हम कुकीज़ के उपयोग के तरीके में महत्वपूर्ण बदलाव करते हैं, तो हम हमारी वेबसाइट पर या अन्य उपयुक्त माध्यमों से अतिरिक्त सूचना प्रदान कर सकते हैं।",
                ],
            },
            {
                id: "contact-us",
                title: "संपर्क करें",
                paragraphs: [
                    "यदि इस कुकी नीति के बारे में या हम अपनी वेबसाइट पर कुकीज़ का उपयोग कैसे करते हैं, इस बारे में आपके कोई प्रश्न हैं, तो कृपया हमारी वेबसाइट पर दिए गए विवरण का उपयोग करके हमसे संपर्क करें।",
                    "हम आपकी पूछताछ का यथासंभव शीघ्र उत्तर देंगे और कुकीज़ या आपकी गोपनीयता प्राथमिकताओं से संबंधित किसी भी चिंता में सहायता करने में प्रसन्न होंगे।",
                    "हम व्यक्तिगत डेटा को कैसे संभालते हैं, इस बारे में सामान्य जानकारी के लिए आप हमारी गोपनीयता नीति का भी संदर्भ ले सकते हैं, जो हमारी वेबसाइट पर उपलब्ध है।",
                ],
            },
        ],
    },
    privacyPolicy: {
        title: "गोपनीयता नीति",
        subtitle: "यह पृष्ठ बताता है कि जब आप हमारी वेबसाइट पर आते हैं या ऑनलाइन हमारे साथ संवाद करते हैं तो हम व्यक्तिगत जानकारी कैसे एकत्र, उपयोग और सुरक्षित कर सकते हैं।",
        onThisPage: "इस पृष्ठ पर",
        sections: [
            {
                id: "introduction",
                title: "परिचय",
                paragraphs: [
                    "यह गोपनीयता नीति बताती है कि जब आप हमारी वेबसाइट पर आते हैं, हमसे संपर्क करते हैं, या हमारी सेवाओं के साथ संवाद करते हैं तो हम व्यक्तिगत जानकारी को कैसे एकत्र, उपयोग और संभाल सकते हैं। हम आपको व्यक्तिगत डेटा के संबंध में हमारी सामान्य प्रथाओं को समझने के लिए इस पृष्ठ को पढ़ने के लिए प्रोत्साहित करते हैं।",
                    "हमारी वेबसाइट का उपयोग करके या हमें जानकारी प्रदान करके, आप स्वीकार करते हैं कि आपकी व्यक्तिगत जानकारी को इस नीति में वर्णित तरीके से संसाधित किया जा सकता है। यदि आप इन प्रथाओं से सहमत नहीं हैं, तो आप हमारी वेबसाइट का उपयोग न करने या हमारे फ़ॉर्म के माध्यम से व्यक्तिगत जानकारी न देने का विकल्प चुन सकते हैं।",
                    "यह नीति हमारी वेबसाइट और संबंधित ऑनलाइन चैनलों के माध्यम से एकत्र की गई जानकारी पर लागू होती है। यह ऑफ़लाइन या ऐसी तृतीय-पक्ष वेबसाइटों के माध्यम से एकत्र की गई जानकारी को कवर नहीं करती जो हमारी साइट से लिंक हो सकती हैं।",
                ],
            },
            {
                id: "information-we-collect",
                title: "हम कौन-सी जानकारी एकत्र करते हैं",
                paragraphs: [
                    "जब आप संपर्क फ़ॉर्म भरते हैं, जानकारी का अनुरोध करते हैं, अपडेट की सदस्यता लेते हैं, या अन्यथा हमसे संवाद करते हैं, तो हम वह जानकारी एकत्र कर सकते हैं जो आप स्वेच्छा से प्रदान करते हैं। इसमें आपका नाम, ईमेल पता, फ़ोन नंबर, कंपनी का नाम और आपके संदेश की सामग्री शामिल हो सकती है।",
                    "जब आप हमारी वेबसाइट पर आते हैं, तो हम कुछ तकनीकी जानकारी स्वचालित रूप से एकत्र कर सकते हैं, जैसे आपका ब्राउज़र प्रकार, डिवाइस प्रकार, ऑपरेटिंग सिस्टम, IP पता, संदर्भित URL और आप हमारे पृष्ठों के साथ कैसे संवाद करते हैं, इसका सामान्य उपयोग डेटा।",
                    "हम तृतीय-पक्ष सेवा प्रदाताओं से भी जानकारी प्राप्त कर सकते हैं जो हमारी वेबसाइट को संचालित करने में हमारी मदद करते हैं, जैसे एनालिटिक्स या होस्टिंग सेवाएँ। एकत्र की गई जानकारी के प्रकार उपयोग की गई सेवाओं और आपकी ब्राउज़र सेटिंग्स पर निर्भर करते हैं।",
                    "हम जानबूझकर संवेदनशील व्यक्तिगत जानकारी एकत्र नहीं करते जब तक कि आप इसे किसी संदेश या फ़ॉर्म सबमिशन में शामिल करने का चयन न करें। कृपया ऐसी जानकारी भेजने से बचें जिसे आप हमारी वेबसाइट के माध्यम से साझा नहीं करना चाहते।",
                ],
            },
            {
                id: "how-we-use-your-information",
                title: "हम आपकी जानकारी का उपयोग कैसे करते हैं",
                paragraphs: [
                    "हम एकत्र की गई जानकारी का उपयोग आपकी पूछताछ का उत्तर देने, अनुरोधित जानकारी प्रदान करने और जहाँ उपयुक्त हो, हमारे उत्पादों, सेवाओं या अपडेट के बारे में आपसे संवाद करने के लिए कर सकते हैं।",
                    "तकनीकी और उपयोग संबंधी जानकारी का उपयोग हमारी वेबसाइट को बनाए रखने और सुधारने, आगंतुक प्राथमिकताओं को समझने, प्रदर्शन की निगरानी करने और हमें अपने दर्शकों के लिए प्रासंगिक सामग्री विकसित करने में मदद करने के लिए किया जा सकता है।",
                    "हम एकत्र की गई जानकारी का उपयोग आंतरिक व्यावसायिक उद्देश्यों के लिए भी कर सकते हैं, जैसे रिकॉर्ड रखना, गुणवत्ता समीक्षा और हमारी ऑनलाइन उपस्थिति का सामान्य प्रशासन।",
                    "हम आम तौर पर हमारी वेबसाइट के साथ आपके संवाद, हमारी सेवाओं को संचालित करने और सुधारने में हमारे वैध व्यावसायिक हितों, और जहाँ लागू हो, आपकी सहमति के आधार पर जानकारी संसाधित करते हैं।",
                ],
            },
            {
                id: "cookies-and-tracking",
                title: "कुकीज़ और ट्रैकिंग तकनीकें",
                paragraphs: [
                    "हमारी वेबसाइट प्राथमिकताओं को याद रखने, बुनियादी साइट कार्यक्षमता का समर्थन करने और आगंतुक हमारे पृष्ठों का उपयोग कैसे करते हैं, इसके बारे में जानकारी एकत्र करने के लिए कुकीज़ और समान तकनीकों का उपयोग कर सकती है।",
                    "कुकीज़ छोटी टेक्स्ट फ़ाइलें होती हैं जो आपके ब्राउज़र द्वारा आपके डिवाइस पर संग्रहीत की जाती हैं। ये सत्र कुकीज़ हो सकती हैं, जो आपके ब्राउज़र बंद करने पर समाप्त हो जाती हैं, या स्थायी कुकीज़, जो समाप्त होने या हटाए जाने तक बनी रहती हैं।",
                    "आप आमतौर पर अपनी ब्राउज़र सेटिंग्स के माध्यम से कुकीज़ प्रबंधित या अक्षम कर सकते हैं। कृपया ध्यान दें कि कुकीज़ को प्रतिबंधित करने से हमारी वेबसाइट की कुछ सुविधाएँ या समग्र अनुभव प्रभावित हो सकता है।",
                    "जहाँ हम एनालिटिक्स या समान उपकरणों का उपयोग करते हैं, वे सेवाएँ ट्रैफ़िक पैटर्न और साइट उपयोग को समझने में हमारी मदद के लिए समग्र या डिवाइस-स्तरीय जानकारी एकत्र कर सकती हैं। उनका उपयोग उनकी अपनी नीतियों के अधीन है।",
                ],
            },
            {
                id: "data-sharing",
                title: "डेटा साझाकरण और तृतीय-पक्ष सेवाएँ",
                paragraphs: [
                    "हम व्यक्तिगत जानकारी नहीं बेचते। हम विश्वसनीय सेवा प्रदाताओं के साथ जानकारी साझा कर सकते हैं जो हमारी वेबसाइट संचालित करने, सामग्री होस्ट करने, संचार प्रदान करने या साइट प्रदर्शन का विश्लेषण करने में हमारी सहायता करते हैं।",
                    "ये प्रदाता हमारी ओर से जानकारी संसाधित कर सकते हैं और आम तौर पर उनसे अपेक्षा की जाती है कि वे इसका उपयोग केवल उन सेवाओं के लिए करें जो वे हमारे लिए करते हैं। हम लागू कानून, विनियमन, कानूनी प्रक्रिया या सरकारी अनुरोध द्वारा आवश्यक होने पर भी जानकारी साझा कर सकते हैं।",
                    "हमारी वेबसाइट में बाहरी वेबसाइटों या सेवाओं के लिंक हो सकते हैं जो हमारे द्वारा संचालित नहीं हैं। हम उन तृतीय पक्षों की गोपनीयता प्रथाओं के लिए ज़िम्मेदार नहीं हैं, और हम आपको व्यक्तिगत जानकारी प्रदान करने से पहले उनकी नीतियों की समीक्षा करने के लिए प्रोत्साहित करते हैं।",
                    "किसी व्यावसायिक परिवर्तन की स्थिति में, जैसे विलय, अधिग्रहण या पुनर्गठन, व्यक्तिगत जानकारी उस लेन-देन के हिस्से के रूप में स्थानांतरित की जा सकती है, जो लागू आवश्यकताओं के अधीन होगी।",
                ],
            },
            {
                id: "data-security",
                title: "डेटा सुरक्षा",
                paragraphs: [
                    "हम व्यक्तिगत जानकारी को अनधिकृत पहुँच, प्रकटीकरण, परिवर्तन या हानि से बचाने के लिए बनाए गए उचित प्रशासनिक, तकनीकी और संगठनात्मक उपाय अपनाते हैं।",
                    "हालाँकि, इंटरनेट पर प्रसारण का कोई भी तरीका या इलेक्ट्रॉनिक भंडारण का कोई भी तरीका पूरी तरह सुरक्षित नहीं है। जबकि हम जानकारी की सुरक्षा के लिए काम करते हैं, हम हमारे द्वारा प्रसारित या संग्रहीत डेटा की पूर्ण सुरक्षा सुनिश्चित नहीं कर सकते।",
                    "जहाँ लागू हो, आप हमारी सेवाओं के आपके उपयोग से जुड़े किसी भी क्रेडेंशियल या पहुँच विवरण की गोपनीयता बनाए रखने के लिए ज़िम्मेदार हैं।",
                    "यदि आपको लगता है कि हमारे साथ आपका संवाद अब सुरक्षित नहीं है, तो कृपया नीचे दिए गए विवरण का उपयोग करके हमसे संपर्क करें ताकि हम मामले की समीक्षा कर सकें।",
                ],
            },
            {
                id: "your-rights",
                title: "आपके अधिकार",
                paragraphs: [
                    "आपके स्थान और लागू कानून के आधार पर, हमारे पास आपके बारे में मौजूद व्यक्तिगत जानकारी के संबंध में आपके पास कुछ विकल्प हो सकते हैं। इनमें आपकी जानकारी तक पहुँच, सुधार या हटाने का अनुरोध करने की क्षमता शामिल हो सकती है।",
                    "आप उन संदेशों में दिए गए सदस्यता समाप्ति निर्देशों का पालन करके या सीधे हमसे संपर्क करके हमसे मार्केटिंग संचार प्राप्त करने से भी ऑप्ट आउट कर सकते हैं।",
                    "अपनी व्यक्तिगत जानकारी से संबंधित अनुरोध सबमिट करने के लिए, कृपया इस नीति में दिए गए संपर्क विवरण का उपयोग करें। कुछ अनुरोधों का उत्तर देने से पहले हमें आपकी पहचान सत्यापित करने की आवश्यकता हो सकती है।",
                    "हम लागू कानूनी आवश्यकताओं और हमारी आंतरिक प्रक्रियाओं के अनुसार अनुरोधों पर विचार करेंगे और उनका उत्तर देंगे।",
                ],
            },
            {
                id: "policy-changes",
                title: "इस गोपनीयता नीति में परिवर्तन",
                paragraphs: [
                    "हम अपनी प्रथाओं, सेवाओं या परिचालन आवश्यकताओं में बदलावों को दर्शाने के लिए समय-समय पर इस गोपनीयता नीति को अपडेट कर सकते हैं। जब हम बदलाव करते हैं, तो हम प्रभावी तिथि को संशोधित करेंगे या इस पृष्ठ पर एक अद्यतन संस्करण पोस्ट करेंगे।",
                    "हम आपको यह जानने के लिए कि हम व्यक्तिगत जानकारी को कैसे संभाल सकते हैं, समय-समय पर इस नीति की समीक्षा करने के लिए प्रोत्साहित करते हैं। बदलाव पोस्ट होने के बाद हमारी वेबसाइट का निरंतर उपयोग अद्यतन नीति के प्रति आपकी स्वीकृति का संकेत हो सकता है।",
                    "यदि हम ऐसे भौतिक बदलाव करते हैं जो व्यक्तिगत जानकारी को संभालने के तरीके को महत्वपूर्ण रूप से प्रभावित करते हैं, तो हम जहाँ उपयुक्त हो, अतिरिक्त सूचना प्रदान कर सकते हैं।",
                ],
            },
            {
                id: "contact-us",
                title: "संपर्क करें",
                paragraphs: [
                    "यदि इस गोपनीयता नीति के बारे में या हम व्यक्तिगत जानकारी को कैसे संभालते हैं, इस बारे में आपके कोई प्रश्न हैं, तो कृपया हमारी वेबसाइट पर उपलब्ध संपर्क विकल्पों का उपयोग करके हमसे संपर्क करें।",
                    "संपर्क करते समय, कृपया पर्याप्त विवरण शामिल करें ताकि हम आपकी पूछताछ को समझ सकें और उसका उत्तर दे सकें। हम उचित अनुरोधों की समय पर समीक्षा और समाधान करने का लक्ष्य रखते हैं।",
                    "सामान्य व्यावसायिक पूछताछ के लिए, आप हमारी वेबसाइट पर सूचीबद्ध संपर्क जानकारी का भी उपयोग कर सकते हैं। हम हमारी गोपनीयता प्रथाओं में आपकी रुचि की सराहना करते हैं और आपकी प्रतिक्रिया का स्वागत करते हैं।",
                ],
            },
        ],
    },
    terms: {
        title: "नियम और शर्तें",
        subtitle: "ये नियम इस वेबसाइट तक पहुँच और उपयोग को नियंत्रित करते हैं। कृपया हमारी साइट का उपयोग करने से पहले इन्हें ध्यान से पढ़ें।",
        onThisPage: "इस पृष्ठ पर",
        sections: [
            {
                id: "introduction",
                title: "परिचय",
                paragraphs: [
                    "ये नियम और शर्तें इस वेबसाइट तक आपकी पहुँच और उपयोग को नियंत्रित करती हैं। हमारी साइट पर आकर या उसका उपयोग करके, आप इन नियमों और हमारी संबंधित नीतियों से बंधे होने के लिए सहमत होते हैं।",
                    "यह वेबसाइट सामान्य सूचनात्मक उद्देश्यों के लिए प्रदान की गई है। इस साइट की सामग्री हमारे व्यवसाय, उत्पादों, सेवाओं और हमारे आगंतुकों के लिए रुचि के अन्य विषयों का वर्णन कर सकती है।",
                    "कृपया वेबसाइट का उपयोग करने से पहले इन नियमों को ध्यान से पढ़ें। यदि आप इन नियमों के किसी भाग से सहमत नहीं हैं, तो आपको साइट का उपयोग बंद कर देना चाहिए।",
                ],
            },
            {
                id: "acceptance-of-terms",
                title: "नियमों की स्वीकृति",
                paragraphs: [
                    "इस वेबसाइट तक पहुँचकर या उसका उपयोग करके, आप पुष्टि करते हैं कि आपने इन नियमों और शर्तों को पढ़ा, समझा है और उनसे सहमत हैं। साइट का आपका निरंतर उपयोग इन नियमों की निरंतर स्वीकृति का गठन करता है।",
                    "यदि आप किसी संगठन की ओर से इस वेबसाइट का उपयोग कर रहे हैं, तो आप प्रतिनिधित्व करते हैं कि आपके पास उस संगठन को इन नियमों से बाँधने का अधिकार है।",
                    "हम समय-समय पर इन नियमों को अपडेट कर सकते हैं। जब बदलाव पोस्ट किए जाते हैं, तो वेबसाइट का आपका निरंतर उपयोग संशोधित नियमों की आपकी स्वीकृति का संकेत हो सकता है।",
                ],
            },
            {
                id: "use-of-the-website",
                title: "वेबसाइट का उपयोग",
                paragraphs: [
                    "आप इस वेबसाइट का उपयोग वैध उद्देश्यों के लिए और इन नियमों के अनुरूप तरीके से कर सकते हैं। आप सहमत होते हैं कि आप साइट का उपयोग किसी भी ऐसे तरीके से नहीं करेंगे जिससे इसके संचालन को नुकसान, अक्षम, अतिभारित या ख़राब किया जा सके।",
                    "आप वेबसाइट, संबंधित प्रणालियों या नेटवर्क के किसी भी हिस्से तक अनधिकृत पहुँच प्राप्त करने का प्रयास नहीं कर सकते। आप साइट या उसकी सामग्री की सुरक्षा या अखंडता में हस्तक्षेप न करने के लिए भी सहमत होते हैं।",
                    "यदि हमें लगता है कि साइट का उपयोग इन नियमों का उल्लंघन करता है या साइट या अन्य उपयोगकर्ताओं के लिए जोखिम पैदा करता है, तो हम किसी भी समय, सूचना के साथ या बिना सूचना के, वेबसाइट तक पहुँच को प्रतिबंधित या समाप्त करने का अधिकार सुरक्षित रखते हैं।",
                    "इस वेबसाइट की जानकारी सामान्य आधार पर प्रदान की गई है और बिना पूर्व सूचना के बदली या अपडेट की जा सकती है। हम गारंटी नहीं देते कि साइट हर समय उपलब्ध रहेगी या त्रुटियों या रुकावटों से मुक्त होगी।",
                ],
            },
            {
                id: "intellectual-property",
                title: "बौद्धिक संपदा",
                paragraphs: [
                    "इस वेबसाइट की सभी सामग्री, जिसमें टेक्स्ट, ग्राफ़िक्स, लोगो, चित्र, लेआउट और अन्य सामग्री शामिल है, हमारे स्वामित्व में है या अनुमति के साथ उपयोग की जाती है और लागू बौद्धिक संपदा कानूनों द्वारा संरक्षित है।",
                    "जब तक लिखित रूप में अन्यथा अनुमति न दी जाए, आप इस वेबसाइट की सामग्री को केवल व्यक्तिगत, गैर-व्यावसायिक उपयोग के लिए देख और डाउनलोड कर सकते हैं। आप पूर्व प्राधिकरण के बिना साइट सामग्री की प्रतिलिपि, पुनरुत्पादन, वितरण, संशोधन या व्युत्पन्न कार्य नहीं बना सकते।",
                    "इस वेबसाइट पर प्रदर्शित ट्रेडमार्क, सेवा चिह्न और व्यापार नाम संबंधित स्वामी की पूर्व लिखित सहमति के बिना उपयोग नहीं किए जा सकते।",
                    "इस वेबसाइट की किसी भी सामग्री का अनधिकृत उपयोग कॉपीराइट, ट्रेडमार्क या अन्य लागू कानूनों का उल्लंघन कर सकता है और इसके परिणामस्वरूप कानूनी कार्रवाई हो सकती है।",
                ],
            },
            {
                id: "user-responsibilities",
                title: "उपयोगकर्ता की ज़िम्मेदारियाँ",
                paragraphs: [
                    "आप यह सुनिश्चित करने के लिए ज़िम्मेदार हैं कि इस वेबसाइट के माध्यम से आपके द्वारा सबमिट की गई कोई भी जानकारी सटीक, पूर्ण और उपयुक्त हो। आप झूठी, भ्रामक या गैरकानूनी सामग्री सबमिट न करने के लिए सहमत होते हैं।",
                    "यदि आप इस साइट से लिंक किए गए फ़ॉर्म, ईमेल या अन्य चैनलों के माध्यम से हमसे संपर्क करते हैं, तो आप सम्मानपूर्वक संवाद करने और हानिकारक, आपत्तिजनक या अनधिकृत सामग्री प्रसारित न करने के लिए सहमत होते हैं।",
                    "जहाँ लागू हो, आप हमारी सेवाओं के आपके उपयोग से जुड़े किसी भी खाता क्रेडेंशियल या पहुँच विवरण की गोपनीयता बनाए रखने के लिए ज़िम्मेदार हैं।",
                    "आप इस वेबसाइट का उपयोग करते समय और हमारे द्वारा प्रदान किए गए किसी भी ऑनलाइन चैनल के माध्यम से हमारे साथ संवाद करते समय सभी लागू कानूनों और विनियमों का पालन करने के लिए सहमत होते हैं।",
                ],
            },
            {
                id: "limitation-of-liability",
                title: "दायित्व की सीमा",
                paragraphs: [
                    "यह वेबसाइट और इसकी सामग्री \"जैसी है\" और \"जैसी उपलब्ध है\" के आधार पर प्रदान की जाती है। लागू कानून द्वारा अनुमत पूर्ण सीमा तक, हम साइट और इसकी सामग्री के संबंध में सभी वारंटियों को अस्वीकार करते हैं, चाहे वे स्पष्ट हों या निहित।",
                    "हम यह वारंटी नहीं देते कि वेबसाइट निर्बाध, त्रुटि-मुक्त, सुरक्षित, या वायरस या अन्य हानिकारक घटकों से मुक्त होगी। आप साइट का उपयोग अपने जोखिम पर करते हैं।",
                    "लागू कानून द्वारा अनुमत अधिकतम सीमा तक, हम इस वेबसाइट के आपके उपयोग से उत्पन्न या उससे संबंधित किसी भी अप्रत्यक्ष, आकस्मिक, विशेष, परिणामी या दंडात्मक क्षति के लिए उत्तरदायी नहीं होंगे।",
                    "इन नियमों में कुछ भी दायित्व को बाहर या सीमित नहीं करता जहाँ ऐसा बहिष्करण या सीमा लागू कानून द्वारा अनुमत नहीं है।",
                ],
            },
            {
                id: "third-party-links",
                title: "तृतीय-पक्ष लिंक",
                paragraphs: [
                    "इस वेबसाइट में तृतीय-पक्ष वेबसाइटों या सेवाओं के लिंक हो सकते हैं जो हमारे स्वामित्व या नियंत्रण में नहीं हैं। ये लिंक केवल सुविधा और सूचनात्मक उद्देश्यों के लिए प्रदान किए गए हैं।",
                    "हम किसी भी तृतीय-पक्ष साइट या सेवाओं की सामग्री, नीतियों, प्रथाओं या उपलब्धता का समर्थन नहीं करते और उनके लिए ज़िम्मेदार नहीं हैं। तृतीय-पक्ष वेबसाइटों का आपका उपयोग आपके अपने विवेक और जोखिम पर है।",
                    "हम आपको आपके द्वारा देखी जाने वाली किसी भी तृतीय-पक्ष वेबसाइट के नियमों और गोपनीयता नीतियों की समीक्षा करने के लिए प्रोत्साहित करते हैं। हम तृतीय-पक्ष सामग्री या सेवाओं के आपके उपयोग या उन पर निर्भरता से उत्पन्न किसी भी हानि या क्षति के लिए उत्तरदायी नहीं हैं।",
                ],
            },
            {
                id: "changes-to-these-terms",
                title: "इन नियमों में परिवर्तन",
                paragraphs: [
                    "हम अपनी वेबसाइट, व्यावसायिक प्रथाओं या कानूनी आवश्यकताओं में बदलावों को दर्शाने के लिए किसी भी समय इन नियमों और शर्तों को संशोधित कर सकते हैं। अद्यतन नियम, जहाँ लागू हो, संशोधित प्रभावी तिथि के साथ इस पृष्ठ पर पोस्ट किए जाएँगे।",
                    "इन नियमों की समय-समय पर समीक्षा करना आपकी ज़िम्मेदारी है। बदलाव पोस्ट होने के बाद वेबसाइट का निरंतर उपयोग अद्यतन नियमों की आपकी स्वीकृति का गठन कर सकता है।",
                    "यदि हम भौतिक बदलाव करते हैं, तो हम जहाँ उपयुक्त हो, वेबसाइट पर या अन्य उचित माध्यमों से अतिरिक्त सूचना प्रदान कर सकते हैं।",
                ],
            },
            {
                id: "governing-law",
                title: "शासी कानून",
                paragraphs: [
                    "ये नियम और शर्तें लागू कानूनों द्वारा शासित और उनके अनुसार व्याख्यायित की जाएँगी, कानून के टकराव के सिद्धांतों की परवाह किए बिना।",
                    "इन नियमों से या इस वेबसाइट के आपके उपयोग से उत्पन्न या उससे संबंधित कोई भी विवाद लागू कानून द्वारा नामित अदालतों या न्यायाधिकरणों के क्षेत्राधिकार के अधीन होगा।",
                    "यदि इन नियमों का कोई प्रावधान अमान्य या अप्रवर्तनीय पाया जाता है, तो शेष प्रावधान लागू कानून द्वारा अनुमत सीमा तक पूर्ण बल और प्रभाव में बने रहेंगे।",
                ],
            },
            {
                id: "contact-us",
                title: "संपर्क करें",
                paragraphs: [
                    "यदि इन नियमों और शर्तों के बारे में या इस वेबसाइट के आपके उपयोग के बारे में आपके कोई प्रश्न हैं, तो कृपया हमारी वेबसाइट पर उपलब्ध संपर्क विकल्पों का उपयोग करके हमसे संपर्क करें।",
                    "संपर्क करते समय, कृपया पर्याप्त विवरण शामिल करें ताकि हम आपकी पूछताछ को समझ सकें और उसका उत्तर दे सकें। हम उचित अनुरोधों की समय पर समीक्षा और समाधान करने का लक्ष्य रखते हैं।",
                    "सामान्य व्यावसायिक पूछताछ के लिए, आप हमारी वेबसाइट पर सूचीबद्ध संपर्क जानकारी का भी उपयोग कर सकते हैं। हम आपकी रुचि की सराहना करते हैं और आपकी प्रतिक्रिया का स्वागत करते हैं।",
                ],
            },
        ],
    },
    crops: ["अंगूर", "अनार", "केला", "कपास", "टमाटर", "सोयाबीन", "गन्ना", "सब्जियां", "प्याज", "मिर्च", "अन्य"],
};
